import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { Box, Checkbox as MuiCheckbox, Stack, Typography } from '@mui/material';

import { useLanguage } from '~/hooks/language';

interface Props {
  className?: string;
  value?: string;
}

const patterns = {
  lower: /[a-z]/,
  upper: /[A-Z]/,
  number: /[0-9]/,
  count: /.{8,}/,
};

interface RuleProps {
  active: boolean;
  label: string;
}

const PasswordRule: React.FC<RuleProps> = ({ active, label }) => (
  <Box display="flex" alignItems="center" gap={1}>
    <MuiCheckbox
      checked={active}
      disableRipple
      icon={<RadioButtonUncheckedIcon fontSize="small" />}
      checkedIcon={<CheckCircleIcon fontSize="small" />}
      sx={{
        p: 0,
        color: 'text.disabled',
        '&.Mui-checked': {
          color: 'success.main',
        },
      }}
    />
    <Typography variant="body2" color={active ? 'text.primary' : 'text.secondary'}>
      {label}
    </Typography>
  </Box>
);

export function PasswordFieldChecker({ value = '' }: Props) {
  const { translate: t } = useLanguage('ua');

  return (
    <Stack spacing={1}>
      <PasswordRule active={patterns.lower.test(value)} label={t('passwordFieldChecker.lowerCase')} />
      <PasswordRule active={patterns.upper.test(value)} label={t('passwordFieldChecker.upperCase')} />
      <PasswordRule active={patterns.number.test(value)} label={t('passwordFieldChecker.number')} />
      <PasswordRule active={patterns.count.test(value)} label={t('passwordFieldChecker.count')} />
    </Stack>
  );
}

export default PasswordFieldChecker;
